import React from "react";

export const CloClo = <span>Inaturalist User <a href="https://www.inaturalist.org/people/cloclo53">cloclo53</a></span>
